import {
  FETCH_MEDIA_ITEM_REQUEST,
  FETCH_MEDIA_ITEM_SUCCESS,
  FETCH_MEDIA_ITEM_FAILURE,
  FETCH_MEDIA_REQUEST,
  FETCH_MEDIA_SUCCESS,
  FETCH_MEDIA_FAILURE,
} from '../actions';

const defaultMediaState = {
  media: [],
  loading: false,
  error: false
};

const reducer = (state = defaultMediaState, action) => {
  switch(action.type){
    case FETCH_MEDIA_REQUEST:
      return {
        ...state,
        loading: true,
        mediaLoaded: false,
      };
    case FETCH_MEDIA_SUCCESS:
      directors = [];
      media = [];

      if(state.directors.length > 0){
        // directors loaded, map director info & ACF into media
        state.directors.map(director => {
          videos = [];

          director.acf.videos && director.acf.videos.map(video => {
            const attachment = find(action.media, {'id': video.video.id});
            video.video.acf = attachment ? attachment.acf : false;
            video.video.director = {
              title: director.title.rendered,
              slug: director.slug,
              id: director.id,
              primary_color: director.acf.primary_color,
              secondary_color: director.acf.secondary_color,
            };

            videos.push(video);
            media.push(video.video);
          })

          director.acf.videos = videos
          directors.push(director);
        });
      }else{
        //directors not loaded yet, load media
        media = action.media;
      }

      return {
        ...state,
        directors,
        media,
        loading: false,
        mediaLoaded: true,
      };
    case FETCH_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        mediaLoaded: false,
        error: true
      };
    case FETCH_MEDIA_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_MEDIA_ITEM_SUCCESS:
      let media = state.media;

      // TODO: maybe de-dup?
      media.push(action.mediaItem);

      return {
        ...state,
        media,
        loading: false,
      };
    case FETCH_MEDIA_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };
    default:
      return state;
  }
}

export default reducer;
